import { makeTablesResponsive } from './responsiveTables';

const ajaxInitializationSelector = '[data-ajax-initialization-url]';
const ajaxInitializationUrlKey = 'ajax-initialization-url';

startAjaxInitialization($('body'));

function startAjaxInitialization(scope: JQuery<HTMLElement>) {
    scope.find(ajaxInitializationSelector).each((i, element) => {
        const jqueryElement = $(element);

        const initializationUrl = jqueryElement.data(ajaxInitializationUrlKey);
        $.get(initializationUrl, (result) => {
            const html = $(result);

            jqueryElement.replaceWith(html);
            makeTablesResponsive(html);
        });
    });
}
